function formatNumber(value, { decimals = 2 } = {}) {
    const numberFormat = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
    return numberFormat.format(Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals));
}
export { formatNumber };
//# sourceMappingURL=formatNumber.js.map